import { stringify } from 'query-string';
import { entityTypeToApiType } from 'helpers/mapEntityTypes';
import getCountryIds from 'helpers/getCountryIds';
import { MAX_LIMIT } from 'config';

export default getShortFormVideoKPICountries;
export { getShortFormVideoKPICountries };

/**
 * This URL constructor creates a URL for ShortFormVideo countries.
 * @param {object} args URL constructor arguments
 * @param {array} args.countryIds Array of country id's to retrieve data for, if omitted data should be returned as broken down (split out) to each country separately
 * @param {boolean} args.download When this parameter is supplied as true the API returns a plain-text csv.
 * @param {array} args.entityIds Array of entity id's to retrieve data for
 * @param {number} args.limit Number of items that should be returned in the response.
 * @param {number} args.offset Offset for the returned selection of the result set.
 * @param {('track' | 'artist' | 'album' | 'project')} args.shortFormVideoEntityType Entity type that supports showing data for ShortFormVideo
 * @param {('countThisWeekToDate'|'countLastWeek')} args.sortBy What metric to sort the list by for ShortFormVideo
 * @param {('asc'|'desc')} args.sortOrder What order to sort the list by
 * @param {(views' | 'creations')} args.metricType What metric type
 * @returns {string} ShortFormVideo Countries URL for tracks and artists
 */

export interface IProps {
  countryIds?: any;
  download?: boolean;
  entityIds: string[];
  limit?: number;
  offset?: number;
  entityType: 'track' | 'artist' | 'album' | 'project';
  sortOrder?: string;
  sortBy?: string;
  countryName?: string;
  metricType?: 'views' | 'creations';
  region?: string;
  compareMode?: string;
  customRegion?: string | string[];
  platform?: number;
}

function getShortFormVideoKPICountries(args: IProps): string {
  const {
    countryIds,
    download,
    entityIds,
    limit = MAX_LIMIT,
    offset,
    entityType,
    sortBy,
    sortOrder,
    countryName,
    metricType,
    region,
    customRegion,
    platform,
  } = args;

  const apiEntityType = entityTypeToApiType(entityType);

  const params = stringify({
    countryIds: getCountryIds(countryIds, region, customRegion),
    download,
    limit,
    offset,
    sortBy,
    sortOrder,
    countryName,
    metricType,
    customerFilter: platform,
  });

  return `/api/shortFormVideo/kpi/${apiEntityType}/${entityIds}/countries${
    params !== '' ? `?${params}` : ''
  }`;
}
